export const dollarConverter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
